import { Tab, TabContext, TabList } from '@shared/components';
import { useMemo } from 'react';

import { type QuestionStatus, useQBankStructureDashBoardSearchParams } from '../../hooks';

const TAB_ITEMS: { value: QuestionStatus; label: string }[] = [
  {
    value: 'DRAFT',
    label: 'Draft',
  },
  {
    value: 'PUBLISHED',
    label: 'Published',
  },
  {
    value: 'UNPUBLISHED',
    label: 'Pending',
  },
  {
    value: 'DISABLED',
    label: 'Disabled',
  },
];

interface QBankStructureDashBoardNavigationTabsProps {
  questionStatuses?: QuestionStatus[];
}

export default function QBankStructureDashBoardNavigationTabs(
  props: Readonly<QBankStructureDashBoardNavigationTabsProps>,
) {
  const { questionStatuses } = props;
  const [{ status }, { changeStatus }] = useQBankStructureDashBoardSearchParams();

  const handleClick = (value: QuestionStatus) => {
    changeStatus(value);
  };

  const filteredTabItems = useMemo(
    () => TAB_ITEMS.filter((tab) => questionStatuses?.includes(tab.value)),
    [questionStatuses],
  );

  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          p: theme.spacing(4, 4, 0, 4),
          gap: theme.spacing(4),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        })}
      >
        {filteredTabItems.map((tab) => {
          return (
            <Tab
              key={tab.label}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
              sx={{
                minWidth: 'unset',
              }}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
